import { useRoutes, RouteObject, Navigate } from "react-router-dom";
import Loginemail from "../pages/auth/login";
import Mainmenu from "../components/MainMenu";
import Listcampaign from "../pages/dashboard/campaign/listCampaign";
import Campaign from "../pages/dashboard/campaign";
import Detailcampaign from "../pages/dashboard/campaign/detailCampaign";
import Recover from "../pages/auth/recover";
import Changepassword from "../pages/auth/changePassword";
import Notfound from "../components/notFound";
import MainProfile from "../pages/dashboard/profile/mainProfile";
import Employee from "../pages/dashboard/employee";
import Creteemployee from "../pages/dashboard/employee/create";
import Requireauth from "./requireAuth";
import Redirectmain from "./redirectMain";
import Skills from "../pages/dashboard/skills";
import Roles from "../pages/dashboard/roles";
import Raffle from "../pages/dashboard/raffle";
import DetailRafflecampaign from "../pages/dashboard/raffle/detailCampaign";
import Winner from "../pages/dashboard/winner";
import WinnerList from "../pages/dashboard/winner/winnerList";
import { useAppSelector } from "../store/hooks";

const RouterPurls = () => {
  const { isLogin, token, timelogin } = useAppSelector((state) => state.user);
  console.log(isLogin)
  const rtg: RouteObject[] = [
    {
      path: "",
      element: isLogin ? <Navigate to='/mypurls/campaigns' />: (
        <Redirectmain>
          <Loginemail />
        </Redirectmain>
      ),
    },
    /*  {
      path: 'verify',
      element: isLogin ? <Navigate to='/mypurls/campaigns' /> : token ? <Codeverification /> : <Navigate to='/' />,
    }, */
    {
      path: "forgotpassword",
      element: (
        <Redirectmain>
          <Recover />
        </Redirectmain>
      ),
    },
    {
      path: "forgotpassword/:key",
      element: (
        <Redirectmain>
          <Changepassword />
        </Redirectmain>
      ),
    },
    {
      path: "mypurls",
      element: (
        <Requireauth>
          <Mainmenu />
        </Requireauth>
      ),
      children: [
        {
          path: "campaigns",
          element: <Campaign />,
          children: [
            {
              path: "",
              element: <Listcampaign />,
            },
            {
              path: ":id_campaign",
              element: <Detailcampaign />,
            },
            /*  {
              path: 'marketing',
              element: <Marketing/>
            },
            {
              path: 'marketing/new-link',
              element: <Generanewlink/>
            } */
          ],
        },
        {
          path: "profile",
          element: <MainProfile />,
        },
        /*  {
          path: 'partner',
          element: <Partner/>
        }, */
        /*   {
          path: 'partner/profile',
          element: <Parnetprofile/>
        }, */
        {
          path: "employee",
          children: [
            {
              path: "",
              element: <Employee />,
            },
            {
              path: "create",
              element: <Creteemployee />,
            },
            // {
            //   path: "import",
            //   element: <ImportEmployees />,
            // },
          ],
        },
        {
          path: "skills",
          children: [
            {
              path: "",
              element: <Skills />,
            },
          ],
        },
        {
          path: "roles",
          children: [
            {
              path: "",
              element: <Roles />,
            },
          ],
        },
        {
          path: "sweepstakes",
          element: <Campaign />,
          children: [
            {
              path: "",
              element: <Raffle />,
            },
            {
              path: ":id_campaign",
              element: <DetailRafflecampaign />
            },
          ],
        },
        {
          path: "winner",
          element: <Campaign />,
          children: [
            {
              path: "",
              element: <WinnerList/>
            },
            {
              path: "getawinner",
              element: <Winner />
            },
            {
              path: "getawinner/:id_raffle",
              element: <Winner />
            },
          ],
        },
      ],
    },
    {
      path: "*",
      element: <Notfound />,
    },
  ];
  const reoutes = useRoutes(rtg);

  return <>{reoutes}</>;
};

export default RouterPurls;
